import { withRequestFailureChecks } from "../request-failure-client";
// Public (pre-auth) endpoints on the /web/v1 contract: invitation acceptance
// and browser token rotation. Deliberately not the session client from
// ./client.ts — injecting acquireAccessToken here would have a token refresh
// trigger a token refresh.

import { FetchHttpClient } from "@effect/platform";
import { makeClient } from "@pima/web-api/client";
import { Effect } from "effect";

type PublicClient = Effect.Effect.Success<ReturnType<typeof makeClient>>;

// Built once, lazily, so importing this module has no side effects.
let clientPromise: Promise<PublicClient> | undefined;
export const getPublicClient = (): Promise<PublicClient> => {
  // Same base as the signed-in client: the version is on the group path.
  clientPromise ??= Effect.runPromise(
    makeClient("/api/web", { transformClient: withRequestFailureChecks }).pipe(
      Effect.provide(FetchHttpClient.layer),
    ),
  );
  return clientPromise;
};
